import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.306641 12.5654H15.9822",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.306641 5.56543H23.6931",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.306641 19.5654H23.6931",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }